<div class="pop-up">

  <div class="backArrowSection">
      <ion-icon (click)="goBack()" name="close-outline"></ion-icon>
  </div>

  <img src="assets/imgs/new-check-img.svg" alt="{{ 'validationLogoAlt' | translate }}">
  
  <div class="content">
    <div class="title">
      {{ 'validationCompleted' | translate }}
    </div>
    <div class="description">{{ 'profileValidated' | translate }}</div>
    
    <ion-button expand="block" class="button-edit-profile-share" shape="round" (click) = "goBack()">
        {{ 'continueButton' | translate }}
    </ion-button>   
  </div>

</div>
